module.exports = __webpack_public_path__ + "static/media/Portrait-10139.852580e1.jpg";